module.exports = __webpack_public_path__ + "static/media/Stroke11.a624b431.svg";